// Portal-specific constants + re-exports from @caro/shared
// Domain constants are defined in @caro/shared/constants for sharing with Resident App

export {
  AUTH_KEYS,
  PAGINATION,
  DATE_FORMATS,
  LOCATION_TYPES,
  DEVICE_TYPES,
  DEVICE_STATUS,
  USER_ROLES,
  NOTIFICATION_TYPES,
  WS_CONFIG,
  FILE_UPLOAD,
  CACHE_CONFIG,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  REGEX,
  THEME_COLORS,
  MAP_DEFAULTS,
  APP_VERSION,
} from '@caro/shared/constants';

// Portal-specific configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || process.env.REACT_APP_API_URL || 'https://api.caro.care';
export const APP_NAME = 'Caro Portal';

// Legacy compat aliases — existing portal code uses these directly
export const TOKEN_KEY = 'caro_auth_token';
export const REFRESH_TOKEN_KEY = 'caro_refresh_token';
export const USER_DATA_KEY = 'caro_user_data';
export const DEFAULT_TIMEOUT = 30000;
export const UPLOAD_TIMEOUT = 3600000;
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const WS_URL = import.meta.env.VITE_WS_URL || process.env.REACT_APP_WS_URL || 'ws://localhost:3001';
export const WS_RECONNECT_INTERVAL = 5000;
export const WS_MAX_RECONNECT_ATTEMPTS = 10;
export const MAP_DEFAULT_CENTER = [51.505, -0.09];
export const MAP_DEFAULT_ZOOM = 13;
export const MAX_FILE_SIZE = 20 * 1024 * 1024 * 1024;
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'application/pdf',
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const CACHE_TTL = 5 * 60 * 1000;
export const CACHE_KEY_PREFIX = 'caro_cache_';

// Export all constants as default for convenience
export default {
  API_BASE_URL,
  APP_NAME,
  APP_VERSION: '2.0.0',
  TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_DATA_KEY,
  DEFAULT_TIMEOUT,
  UPLOAD_TIMEOUT,
  DEFAULT_PAGE_SIZE,
  PAGE_SIZE_OPTIONS,
  DATE_FORMAT,
  TIME_FORMAT,
  DATETIME_FORMAT,
  WS_URL,
  WS_RECONNECT_INTERVAL,
  WS_MAX_RECONNECT_ATTEMPTS,
  MAP_DEFAULT_CENTER,
  MAP_DEFAULT_ZOOM,
  MAX_FILE_SIZE,
  ALLOWED_FILE_TYPES,
  CACHE_TTL,
  CACHE_KEY_PREFIX,
};
